import React, {useEffect, useState} from 'react'
import Layout from "../layout/Layout";
import PageLoading from "../components/loading/PageLoading";

import {popErrors} from "../utils/message";
import parse from "html-react-parser";
import {imgs} from "../utils/image";
import {replaceTo, url} from "../utils/urls";
import {Swiper, SwiperSlide} from "swiper/react";
import {Navigation} from "swiper/modules";
import {useParams} from "react-router-dom";
import FixedLoading from "../components/loading/FixedLoading";
import getEGiftLotteryIntro from "../api/egift/lottery/getEGiftLotteryIntro";
import prepareEGiftRaffle from "../api/egift/lottery/prepareEGiftRaffle";

import "../../style/lottery/_lottery_intro.scss";
import {isEmpty, isNotEmpty} from "../utils/strings";
import loginGeevaAccount from "../api/geeva/loginToGeeva";


/**
 * くじギフト紹介ページ（申込後）
 */
const LotteryIntroPage = () => {
  const [ loading, setLoading ] = useState(true);
  const [ waiting, setWaiting ] = useState(false);
  const [lottery, setLottery] = useState({});
  const { card_number_enc } = useParams();
  const [isConsent, setIsConsent] = useState(true);
  const [ email, setEmail ] = useState("");
  const [ password, setPassword ] = useState("");

  const [loggedin, setLoggedin] = useState(false);
  const [registered, setRegistered] = useState(false);


  let ignore = false;
  useEffect(() => {
    if(!ignore) {
      ignore = true;
      // すでに初期化されていたら処理を抜ける
      if (!loading) {
        return;
      }
      /** くじ紹介ページ情報の表示 */
      getEGiftLotteryIntro({
        card_number_enc: card_number_enc,
        callSuccess: (result) => {
          setLottery(result);
          setLoggedin(result["loggedin"]);
          setRegistered(result["registered"]);
          setEmail(result["email"]);
        },
        callError: (error) => {
          console.log(error);
          popErrors(error);
        },
        callFinally: () => {
          setLoading(false);
        },
      });
    }
  }, [loading]);

  /** 抽選の開始処理 */
  const proceedRaffle = () => {
    if(!isConsent) {
      popErrors("利用規約の同意が必要です。「利用規約に同意する」にチェックしてください。");
      return false;
    }
    setWaiting(true);
    prepareEGiftRaffle({
      card_number_enc: card_number_enc,
      callSuccess: (result) => {
        console.log(result["raffle_url"]);
        replaceTo(result["raffle_url"]);
      },
      callError: (error) => {
        console.log(error);
        popErrors(error);
      },
      callFinally: () => {
        setWaiting(false);
      },
    });
  };
  const loginToGeeva = () => {
    let errorMessages = "";
    if(isEmpty(email)) {
      errorMessages = errorMessages + "ログインIDを入力してください\n";
    }

    if(isEmpty(password)) {
      errorMessages = errorMessages + "パスワードを入力してください";
    }

    if(isNotEmpty(errorMessages)) {
      popErrors(errorMessages);
      return false;
    }

    setWaiting(true);
    loginGeevaAccount({
      login_id: email,
      password: password,
      callSuccess: (result) => {
        setLoggedin(result["loggedin"]);
        setRegistered(result["registered"]);
        //replaceTo(result["raffle_url"]);
      },
      callError: (error) => {
        console.log(error);
        popErrors(error);
      },
      callFinally: () => {
        setWaiting(false);
      },
    });

  }

  return (
    (loading ?
        <PageLoading/>
        :
        <Layout meta={{title: "くじギフトの紹介"}}>
          <div id="main" className="container-fluid lottery-container">
            {waiting &&
              <FixedLoading/>
            }
            <div className="row gx-0 lottery-intro page-content" style={{margin: "0 auto", maxWidth: "800px"}}>
              <div className="col-12">
                <div className="main-head item-index_head">
                  <div className="mb-3 text-center">
                    <img src={url("/img/lottery/geeva_lottery.jpg")} className={"img-fluid mx-auto"}/>
                  </div>
                  <div className="txt-size24 mb-3 title-main">抽選で賞品が当るgeevaくじ</div>
                </div>
                <div className="desc">
                  geevaのオンラインギフトをご注文するか<br/>
                  ギフトをもらった方は<br/>
                  geeva会員になると、抽選で賞品が当ります！
                </div>
              </div>
              <div className="col-12 lottery-gallery">

                {/*  賞品一覧スライド */}
                <Swiper
                  modules={[Navigation]}
                  navigation
                  spaceBetween={2}
                  slidesPerView={2}
                  className={"swiper-main my-4"}
                  breakpoints={{
                    // when window width is >= 1024px
                    1024: {
                      width: 1024,
                      slidesPerView: 3,
                    },
                  }}
                >
                  {lottery["lottery_prize_list"].map((prize) =>
                    <SwiperSlide>
                      <div className="prize-item" key={prize["key"]}>
                        {/*  抽選タイトル */}
                        <div className="lottery-title">
                          <div className="lottery-title-inner">
                            {prize["lottery_title"]}
                          </div>
                        </div>
                        {/*  抽選期間 */}
                        <div className="lottery-period">抽選期間：{prize["period"]}</div>
                        {/*  賞品画像 */}
                        <div className="prize-image">
                          <img src={imgs(prize["prize_image"], 400, 400)} className={"img-fluid"} ></img>
                        </div>
                        {/*  賞品タイトル */}
                        <div className="prize-title">{parse(prize["prize_title"])}</div>
                      </div>
                    </SwiperSlide>
                  )}
                </Swiper>
              </div>
              {/*  geeva会員未登録の人たち向け（ */}
              {(!registered && !loggedin) &&
                <>
                  <div className="col-12">
                    <div className={"terms-desc"}>
                      利用規約に同意し「抽選に進む」と<br/>
                      会員登録用のパスワード設定を開始します。
                    </div>
                    <div className="mt-3">
                      <div className="form-check form-check-inline">
                        <input type="checkbox"
                               className="form-check-input"
                               id="consent-terms"
                               onChange={(e) =>
                                 setIsConsent(e.target.checked)}
                               checked={isConsent}
                        />
                        <label className="form-check-label" htmlFor="consent-terms">利用規約に同意する</label>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 mt-5">
                    <div className="main-buttons">
                      <button className="btn btn-primary btn-raffle w-100"
                              onClick={() => proceedRaffle()}>抽選に進む</button>
                    </div>
                  </div>
                </>
              }
              {/*  geeva会員登録済み＆未ログインの人はログインフォームを表示する */}
              {(registered && !loggedin) &&
                <div className="col-12">
                  <div className={"desc mt-3 mb-3"}>
                    geeva会員でログインすると抽選へ進むことが出来ます。
                  </div>
                  <div className={"login-form"}>
                    <div className={"row"}>
                      <label className={"col-12"} htmlFor={"login_id"}>ログインID</label>
                      <input type="text"
                             id={"login_id"}
                             className="form-control col-12"
                             value={email}
                             onChange={(e) => {
                               setEmail(e.target.value);
                             }}
                             placeholder="ログインID（メール）"
                      />
                    </div>
                    <div className={"row mt-2"}>
                      <label className={"col-12"} htmlFor={"password"}>パスワード</label>
                      <input type="password"
                             id={"password"}
                             className="form-control col-12"
                             value={password}
                             onChange={(e) => {
                               setPassword(e.target.value);
                             }}
                             placeholder="パスワード"
                      />
                      <div className={"col-12 mt-4 mb-3"}>
                        <div className="main-buttons">
                        <button className="btn btn-primary btn-login btn-sm w-100"
                                onClick={() => loginToGeeva()}>ログイン</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }
              {(registered && loggedin) &&
              <div className="col-12 mt-5">
                <div className="main-buttons">
                  <button className="btn btn-primary btn-raffle w-100"
                          onClick={() => proceedRaffle()}>抽選に進む</button>
                </div>
              </div>
              }
              <div className="col-12 lottery-footer">
                <div className="lottery-footer-inner">
                  <div className="row footer-item gx-2">
                    <div className="col-12 footer-title1">eギフト専門のｇｅｅｖａ</div>
                    <div className="col-5">
                      <img src={url("/img/lottery/geeva_logo.jpg")} className={"img-fluid"} />
                    </div>
                    <div className="col-7">
                      <div className="footer-desc1">
                        geevaは２万点以上の商品を４０万名以上にお届けしているeギフト専門に販売しています。<br/>
                        有名ブランドや拘りの生産者などの産直品まで幅広い商品をeギフトとして提供しております。
                      </div>
                      <div>
                        <a href="https://www.geeva.co.jp/">https://www.geeva.co.jp/</a>
                      </div>
                    </div>
                  </div>
                  <div className="site-title">運営ECサイト</div>
                  <div className="row footer-item">
                    <div className="col-12 footer-title2">引出物専門ECサイト hikica++（ヒキカ）</div>
                    <div className="col-4">
                      <img src={url("/img/lottery/hikica_logo.jpg")} className={"img-fluid"} />
                    </div>
                    <div className="col-8">
                      <div className="footer-desc2">
                        ３品選べる引出物カードをｇｅｅｖａが初めて開発し販売を開始ししました。毎年５，０００組以上の新郎新婦の引き出物としてご愛顧いただいております。
                      </div>
                      <div>
                        <a href="https://www.geeva.co.jp/">https://www.geeva.co.jp/</a>
                      </div>
                    </div>
                  </div>
                  <div className="row footer-item">
                    <div className="col-12 footer-title2">法人専門オンラインギフトECサイト b<span>i</span>zGeeva（ビズギーバ）</div>
                    <div className="col-4">
                      <img src={url("/img/lottery/bizgeeva_logo.jpg")} className="img-fluid" />
                    </div>
                    <div className="col-8">
                      <div className="footer-desc2">
                        福利厚生や販促などの法人利用に特化したECサイトです。eギフトならではの扱いやすさと多様なギフトのラインナップが大変人気です。<br/>
                        熨斗包装にもフォーマルなご利用にも対応しています。
                      </div>
                      <div>
                        <a href="https://bizgeeva.jp/">https://bizgeeva.jp/</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Layout>
    )
  )
};
export default LotteryIntroPage;